import { cn } from "@/lib/utils";
import { CarIcon } from "lucide-react";

function AppLogo({
  className,
  size = "default",
}: {
  className?: string;
  size?: "default" | "lg";
}) {
  return (
    <div
      className={cn(
        "bg-primary text-primary-foreground flex shrink-0 items-center justify-center rounded-full",

        size === "default" && "size-8 [&_svg]:size-5",
        size === "lg" && "size-16 [&_svg]:size-12",

        className,
      )}
    >
      <CarIcon />
    </div>
  );
}

export { AppLogo };
